// Real Bavaria 35 photos uploaded by owner — sole source for any boat photo on the site.
const BAVARIA_DECK =
  "https://customer-assets.emergentagent.com/job_anchor-management/artifacts/1eytky13_bavaria-35-holiday-252326_5f4e529494c7af.jpg";
const BAVARIA_MOORED_BERMUDA =
  "https://customer-assets.emergentagent.com/job_anchor-management/artifacts/iuftkycw_670835538_10233788604165359_2499077360873268467_n.jpg";
const BAVARIA_INTERIOR =
  "https://customer-assets.emergentagent.com/job_anchor-management/artifacts/whehu9mx_bavaria-35-holiday-252326_5f4ce2622b2b1f.jpg";
const BAVARIA_CABIN1 =
  "https://customer-assets.emergentagent.com/job_anchor-management/artifacts/47cdz2a6_bavaria-35-holiday-252326_5f4ce274c655af.jpg";
const BAVARIA_CABIN2 =
  "https://customer-assets.emergentagent.com/job_anchor-management/artifacts/f1o2x4vy_bavaria-35-holiday-252326_5f4ce250525d4f.jpg";
const BAVARIA_CORRIDOR =
  "https://customer-assets.emergentagent.com/job_anchor-management/artifacts/kpgk9sua_bavaria-35-holiday-252326_5f4ce26d9ac49f.jpg";
const BAVARIA_GALLEY =
  "https://customer-assets.emergentagent.com/job_anchor-management/artifacts/i6kq82r6_bavaria-35-holiday-252326_5f4ce27f74631f.jpg";

export const IMAGES = {
  // Hero & all boat-showing keys point ONLY to the real Bavaria 35 photos.
  hero: BAVARIA_MOORED_BERMUDA,
  deck: BAVARIA_DECK,
  daytime: BAVARIA_DECK,
  // AI-generated Bavaria 35 at Bermuda sunset (one-shot via Nano Banana).
  sunset: "/bavaria-sunset.jpg",
  bermudaMoored: BAVARIA_MOORED_BERMUDA,
  interior: BAVARIA_INTERIOR,
  cabin1: BAVARIA_CABIN1,
  cabin2: BAVARIA_CABIN2,
  corridor: BAVARIA_CORRIDOR,
  galley: BAVARIA_GALLEY,
  overnight: BAVARIA_CABIN1,
  sail1: BAVARIA_DECK,
  // Lifestyle shot for corporate (no boat visible — people clinking glasses).
  corporate:
    "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dining: BAVARIA_INTERIOR,
  // Non-boat lifestyle shots (food, drink) — these don't depict any boat,
  // so they're fine as ambient stock imagery.
  cocktail:
    "https://images.unsplash.com/photo-1574736221883-afa74ab9e1dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjb2NrdGFpbCUyMG9uJTIwYm9hdCUyMG9jZWFufGVufDB8fHx8MTc3NzU5OTI3Nnww&ixlib=rb-4.1.0&q=85",
  wine:
    "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  breakfast:
    "https://images.unsplash.com/photo-1533089860892-a7c6f0a88666?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  // Additional food images for menu page tabs (no boats)
  lunchPlate:
    "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dinnerPlate:
    "https://images.unsplash.com/photo-1504674900247-0877df9cc836?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  kidsPlate:
    "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  veganPlate:
    "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  glutenFreePlate:
    "https://images.unsplash.com/photo-1490645935967-10de6ba17061?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mocktailGlass:
    "https://images.unsplash.com/photo-1497534446932-c925b458314e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  platterBoard:
    "https://images.unsplash.com/photo-1541529086526-db283c563270?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  // Bermuda Mini Bus Tour visuals (AI-generated via Nano Banana, /app/frontend/public)
  busTour: "/bermuda-pink-bus.jpg",
  dockyardWithBus: "/dockyard-with-bus.jpg",
  dockyardNoBus: "/dockyard-no-bus.jpg",
  horseshoeBay: "/horseshoe-bay.jpg",
  bermudaStreet: "/bermuda-pastel-street.jpg",
};

export const EXPERIENCES = [
  {
    slug: "daytime-cruise",
    name: "Daytime Cruise",
    tagline: "Sun, sea, and the Bermuda blues.",
    description:
      "Drift through turquoise coves, drop anchor at a private pink-sand beach, and let the trade winds set the pace. Ideal for families, friends, and sun seekers.",
    image: IMAGES.daytime,
    duration: "From 2 hours",
    pricing: "$300/hr (up to 8 guests)",
  },
  {
    slug: "sunset-sails",
    name: "Sunset Sails",
    tagline: "Golden hour, from the water.",
    description:
      "Board as the island tilts golden. We'll pour something crisp, angle the sails toward the horizon, and watch Bermuda's famous sky do its thing.",
    image: IMAGES.sunset,
    duration: "2 - 3 hours",
    pricing: "$300/hr (up to 8 guests)",
  },
  {
    slug: "corporate-events",
    name: "Corporate Events",
    tagline: "Board meetings, reimagined.",
    description:
      "Offsites, client entertainment, team celebrations. A private, elevated setting with catered menus, premium bar, and attentive crew.",
    image: IMAGES.corporate,
    duration: "Custom",
    pricing: "$300/hr base · Add-ons available",
  },
  {
    slug: "overnight-stays",
    name: "Overnight Stays",
    tagline: "Sleep on the sea.",
    description:
      "A private floating retreat. Three cabins, star-lit decks, breakfast at anchor. Fall asleep to the gentle sway of the Atlantic.",
    image: IMAGES.overnight,
    duration: "Full night",
    pricing: "$1,500 per night",
  },
  {
    slug: "mini-bus-tour",
    name: "Mini Bus Tour",
    tagline: "A *Bermudaful* island experience, on land.",
    description:
      "A tailored, private mini-bus tour of Bermuda — from south-shore pink-sand beaches to crystal caves, historic St. George's, and any stop you'd like to add along the way. Family-friendly, comfortable, and entirely yours.",
    image: IMAGES.busTour,
    duration: "From 4 hours",
    pricing: "$100 for 4 hours · $25 each additional hour",
  },
];

export const ADD_ONS = [
  // Meal services (per guest)
  { id: "Breakfast Service", label: "Breakfast Service", price: 28, unit: "per guest", category: "Meals" },
  { id: "Bermuda Lunch Service", label: "Bermuda Lunch Service", price: 48, unit: "per guest", category: "Meals" },
  { id: "Sunset Dinner Service", label: "Sunset Dinner Service", price: 78, unit: "per guest", category: "Meals" },
  { id: "Kids' Menu", label: "Kids' Menu (per child)", price: 18, unit: "per guest", category: "Meals" },
  // Platters (flat — serves a group)
  { id: "Island Fruit Platter", label: "Island Fruit Platter (serves 4–6)", price: 65, unit: "flat", category: "Platters" },
  { id: "Garden Veggie Platter", label: "Garden Veggie Platter (serves 4–6)", price: 55, unit: "flat", category: "Platters" },
  { id: "Sushi Platter — Captain's", label: "Sushi Platter — Captain's (32 pcs · serves 4)", price: 95, unit: "flat", category: "Platters" },
  { id: "Sushi Platter — Vegetarian", label: "Sushi Platter — Vegetarian (28 pcs · serves 4)", price: 70, unit: "flat", category: "Platters" },
  { id: "Cheese & Charcuterie Board", label: "Cheese & Charcuterie Board (serves 4–6)", price: 75, unit: "flat", category: "Platters" },
  { id: "Mediterranean Mezze Platter", label: "Mediterranean Mezze (serves 4–6)", price: 60, unit: "flat", category: "Platters" },
  // Bar packages (per guest)
  { id: "Signature Bar Package", label: "Signature Bar Package (cocktails · wines · beer)", price: 38, unit: "per guest", category: "Bar" },
  { id: "Mocktail Package", label: "Mocktail Package (zero-proof, full flavour)", price: 18, unit: "per guest", category: "Bar" },
  { id: "Cocktail Tasting", label: "Cocktail Tasting (3 signatures)", price: 30, unit: "per guest", category: "Bar" },
  { id: "Wine Pairing", label: "Wine Pairing (3 glasses)", price: 36, unit: "per guest", category: "Bar" },
];

export const PICKUP_DOCKS = [
  "Albouys Point",
  "Barrs Bay",
  "Darrel's Wharf",
  "Pennos Wharf",
  "Dockyard Wharf",
];

export const TIME_SLOTS = [
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
];

export const BAR_MENU = {
  signatures: [
    {
      name: "The Anchor",
      price: 18,
      desc: "Dark Bermuda rum, fresh ginger beer, lime, a float of bitters. Our house pour.",
    },
    {
      name: "Pink Sand Spritz",
      price: 16,
      desc: "Rosé cava, pink grapefruit, elderflower, a whisper of sea salt.",
    },
    {
      name: "Horizon Line",
      price: 17,
      desc: "Blanco tequila, cucumber, hibiscus, fresh lime. Clean, bright, unbothered.",
    },
    {
      name: "Knot & Nectar",
      price: 17,
      desc: "Aged rum, passionfruit, honey, vanilla, fresh orange.",
    },
    {
      name: "Starboard Smash",
      price: 16,
      desc: "Bourbon, mint, muddled berries, a float of prosecco.",
    },
    {
      name: "Bavaria Breeze",
      price: 15,
      desc: "Gin, tonic, rosemary, grapefruit peel. Light as the wind on our bow.",
    },
  ],
  wines: [
    { name: "Provence Rosé", price: 14, desc: "Glass · dry, pale, summer in a bottle" },
    { name: "Marlborough Sauvignon Blanc", price: 13, desc: "Glass · citrus, grass, ocean air" },
    { name: "Chablis", price: 16, desc: "Glass · mineral, precise, elegant" },
    { name: "Albariño", price: 14, desc: "Glass · salinity, stone fruit, linear" },
    { name: "Malbec Reserva", price: 15, desc: "Glass · plum, cocoa, soft leather" },
    { name: "Pinot Noir", price: 15, desc: "Glass · cherry, earth, silk" },
  ],
  bottles: [
    { name: "Champagne - Veuve Clicquot", price: 140 },
    { name: "Prosecco Superiore", price: 65 },
    { name: "Sancerre", price: 95 },
    { name: "Whispering Angel Rosé", price: 80 },
  ],
  beer_nonalc: [
    { name: "Local Lager", price: 8 },
    { name: "Crisp Pilsner", price: 8 },
    { name: "Hazy IPA", price: 9 },
    { name: "Virgin Anchor (zero-proof)", price: 10 },
    { name: "Cold-Pressed Juice", price: 7 },
    { name: "Coconut Water", price: 6 },
  ],
  mocktails: [
    {
      name: "Pink Sand Sparkler",
      price: 12,
      desc: "Pink grapefruit, elderflower cordial, sparkling water, sea salt rim.",
    },
    {
      name: "Bermuda Sunrise",
      price: 11,
      desc: "Pineapple, passionfruit, fresh lime, grenadine float.",
    },
    {
      name: "Garden Cooler",
      price: 11,
      desc: "Cucumber, mint, lime, tonic, a sprig of rosemary.",
    },
    {
      name: "Coconut Cloud",
      price: 12,
      desc: "Coconut cream, banana, pineapple, lime — frozen and creamy.",
    },
    {
      name: "Ginger Anchor (Virgin)",
      price: 11,
      desc: "Spicy ginger beer, lime, fresh mint, bitters-free.",
    },
    {
      name: "Rosé Lemonade",
      price: 10,
      desc: "Pomegranate, lemonade, raspberry, hint of rose.",
    },
  ],
};

export const FOOD_MENU = {
  breakfast: [
    {
      name: "Sunrise Board",
      price: 28,
      desc: "Island fruits, warm croissants, cultured butter, local honey, Greek yogurt, granola.",
      tags: ["VG"],
    },
    {
      name: "Smoked Salmon Toast",
      price: 22,
      desc: "Sourdough, whipped cream cheese, capers, dill, soft-scrambled egg.",
    },
    {
      name: "Avocado & Sea Salt",
      price: 18,
      desc: "Sourdough, smashed avocado, chili crunch, poached egg, lemon. (GF bread on request)",
      tags: ["VG", "GF*"],
    },
    {
      name: "Banana Bread French Toast",
      price: 20,
      desc: "Thick cut, dark rum syrup, toasted pecans, mascarpone.",
      tags: ["VG"],
    },
    {
      name: "The Captain's Omelette",
      price: 24,
      desc: "Three eggs, goat cheese, roasted peppers, herbs, side of greens.",
      tags: ["VG", "GF"],
    },
  ],
  lunch: [
    {
      name: "Bermuda Fish Sandwich",
      price: 26,
      desc: "Pan-fried snapper, raisin bread, tartar, slaw, pickled onion.",
    },
    {
      name: "Chilled Lobster Roll",
      price: 34,
      desc: "Sweet butter brioche, lemon aioli, tarragon, crisp iceberg.",
    },
    {
      name: "Heirloom & Stracciatella",
      price: 22,
      desc: "Tomatoes, torn basil, olive oil, sea salt, grilled focaccia.",
      tags: ["VG"],
    },
    {
      name: "Yellowfin Poké",
      price: 28,
      desc: "Soy glaze, avocado, sesame, cucumber, jasmine rice.",
      tags: ["GF"],
    },
    {
      name: "Grilled Halloumi Plate",
      price: 21,
      desc: "Watermelon, mint, chili, lime, toasted pistachios.",
      tags: ["VG", "GF"],
    },
    {
      name: "Signature Fish Chowder",
      price: 18,
      desc: "Dark rum, sherry pepper, hearty island stew.",
    },
  ],
  dinner: [
    {
      name: "Whole Grilled Snapper",
      price: 52,
      desc: "Charred lemon, salsa verde, crispy potatoes, seasonal greens.",
      tags: ["GF"],
    },
    {
      name: "Rum-Glazed Short Rib",
      price: 48,
      desc: "Slow-braised, molasses jus, celeriac purée, pickled shallot.",
      tags: ["GF"],
    },
    {
      name: "Seared Diver Scallops",
      price: 44,
      desc: "Brown butter, corn, smoked paprika, fresh herbs.",
      tags: ["GF"],
    },
    {
      name: "Tagliatelle al Limone",
      price: 32,
      desc: "Butter, lemon, parmigiano, black pepper. Simple. Sublime.",
      tags: ["VG"],
    },
    {
      name: "Cedar-Plank Salmon",
      price: 42,
      desc: "Maple glaze, charred citrus, wild rice, bok choy.",
      tags: ["GF"],
    },
    {
      name: "Dark & Stormy Chocolate Pot",
      price: 14,
      desc: "Ginger cream, dark rum ganache, sea salt, shortbread.",
      tags: ["VG"],
    },
  ],
  kids: [
    {
      name: "Captain's Mini Burger",
      price: 14,
      desc: "Soft brioche, milk-fed beef, mild cheddar, ketchup, fries.",
    },
    {
      name: "Buttered Pasta",
      price: 11,
      desc: "Penne, butter, parmesan. (GF pasta on request)",
      tags: ["VG", "GF*"],
    },
    {
      name: "Crispy Fish Goujons",
      price: 13,
      desc: "Local snapper strips, herb dip, fries.",
    },
    {
      name: "Sunshine Fruit Plate",
      price: 9,
      desc: "Pineapple, watermelon, berries, mango, mint.",
      tags: ["VE", "GF"],
    },
    {
      name: "Cheese Toastie",
      price: 9,
      desc: "Sourdough, melty cheddar, side of fruit. (GF bread on request)",
      tags: ["VG", "GF*"],
    },
    {
      name: "Treasure Chest Cookie",
      price: 6,
      desc: "Warm chocolate chunk cookie, vanilla bean ice cream.",
      tags: ["VG"],
    },
  ],
  vegan: [
    {
      name: "Coconut Yogurt Bowl",
      price: 16,
      desc: "Tropical fruit, toasted coconut, granola, maple drizzle.",
      tags: ["VE", "GF"],
    },
    {
      name: "Sea Salt Avocado Toast",
      price: 17,
      desc: "Sourdough, smashed avocado, chili crunch, lemon, microgreens. (GF bread on request)",
      tags: ["VE", "GF*"],
    },
    {
      name: "Heirloom Tomato Plate",
      price: 19,
      desc: "Sea salt, basil oil, focaccia, olives.",
      tags: ["VE"],
    },
    {
      name: "Bermuda Garden Bowl",
      price: 24,
      desc: "Quinoa, roasted carrot, beets, kale, miso-tahini, seeds.",
      tags: ["VE", "GF"],
    },
    {
      name: "Coconut Curry & Rice",
      price: 26,
      desc: "Cauliflower, chickpeas, lime, fragrant jasmine rice.",
      tags: ["VE", "GF"],
    },
    {
      name: "Charred Aubergine Steak",
      price: 28,
      desc: "Romesco, herb salsa, blistered tomatoes, smoked salt.",
      tags: ["VE", "GF"],
    },
    {
      name: "Coconut Sorbet",
      price: 9,
      desc: "Toasted coconut, lime zest, mint.",
      tags: ["VE", "GF"],
    },
  ],
  glutenFree: [
    {
      name: "GF Captain's Omelette",
      price: 24,
      desc: "Three eggs, goat cheese, roasted peppers, herbs, side of greens.",
      tags: ["VG", "GF"],
    },
    {
      name: "Yellowfin Poké Bowl",
      price: 28,
      desc: "Soy glaze, avocado, sesame, cucumber, jasmine rice.",
      tags: ["GF"],
    },
    {
      name: "Grilled Halloumi Plate",
      price: 21,
      desc: "Watermelon, mint, chili, lime, toasted pistachios.",
      tags: ["VG", "GF"],
    },
    {
      name: "Whole Grilled Snapper",
      price: 52,
      desc: "Charred lemon, salsa verde, crispy potatoes, seasonal greens.",
      tags: ["GF"],
    },
    {
      name: "Cedar-Plank Salmon",
      price: 42,
      desc: "Maple glaze, charred citrus, wild rice, bok choy.",
      tags: ["GF"],
    },
    {
      name: "Bermuda Garden Bowl",
      price: 24,
      desc: "Quinoa, roasted carrot, beets, kale, miso-tahini, seeds.",
      tags: ["VE", "GF"],
    },
    {
      name: "Coconut Sorbet",
      price: 9,
      desc: "Toasted coconut, lime zest, mint.",
      tags: ["VE", "GF"],
    },
  ],
  platters: [
    {
      name: "Island Fruit Platter",
      price: 65,
      desc: "Pineapple, watermelon, papaya, mango, passionfruit, berries, mint, served on a wooden board. Serves 4–6.",
      tags: ["VE", "GF"],
    },
    {
      name: "Garden Veggie Platter",
      price: 55,
      desc: "Heirloom tomato, cucumber, carrot, radish, blistered peppers, hummus, baba ganoush, herb oil, focaccia. Serves 4–6.",
      tags: ["VG"],
    },
    {
      name: "Sushi Platter — Captain's Selection",
      price: 95,
      desc: "Yellowfin, salmon, hamachi nigiri, spicy tuna roll, avocado-cucumber roll, rainbow roll. 32 pieces. Serves 4.",
    },
    {
      name: "Sushi Platter — Vegetarian",
      price: 70,
      desc: "Avocado, cucumber, sweet potato tempura, mango-cream cheese, asparagus rolls, edamame. 28 pieces. Serves 4.",
      tags: ["VG"],
    },
    {
      name: "Cheese & Charcuterie Board",
      price: 75,
      desc: "Aged cheddar, manchego, brie, prosciutto, fennel salami, fig jam, honeycomb, marcona almonds, crackers. Serves 4–6.",
    },
    {
      name: "Mediterranean Mezze Platter",
      price: 60,
      desc: "Tzatziki, hummus, marinated olives, dolmas, falafel, halloumi, pita. Serves 4–6.",
      tags: ["VG"],
    },
  ],
};

export const POLICIES = [
  {
    title: "Booking & Deposits",
    body: "A 50% deposit confirms your date. The remaining balance is due 7 days before departure. All rates are in USD and exclusive of 15% gratuity for the crew, which is standard and appreciated.",
  },
  {
    title: "Cancellations",
    body: "Cancel 14+ days in advance for a full refund. Within 14–7 days, deposit is retained but may be applied to a rescheduled date within 12 months. Within 7 days of the charter, deposits are non-refundable.",
  },
  {
    title: "Weather",
    body: "Bermuda weather can shift. If conditions are unsafe, your captain will suggest rescheduling at no cost to you. A light breeze and passing showers are part of the charm — we sail on.",
  },
  {
    title: "Guest Conduct",
    body: "The boat is your private space — please treat her like a good friend's home. Shoes off on deck, soft voices in the cabin at night, and absolutely no smoking onboard. We adore a party; we just ask for respect.",
  },
  {
    title: "Safety",
    body: "Life vests are provided for every guest, including child sizes. A safety briefing is standard at boarding. Non-swimmers are always welcome — just let the captain know.",
  },
  {
    title: "Children & Pets",
    body: "Children are warmly welcomed with an adult present. Well-behaved pets may join by advance request only. Please share any allergies or dietary needs at time of booking.",
  },
  {
    title: "Overnight Charters",
    body: "Three cabins sleep up to six comfortably. Linens, towels, and a full breakfast are included. Quiet hours are observed from 11pm to 7am out of respect for nearby moorings.",
  },
];
